import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { individualRestrictionGuard } from '../../guards/individual-restriction.guard';

export const admin: Routes = [
  { path: 'coupon', redirectTo: 'financial/coupon', pathMatch: 'full' },
  {
    path: 'financial',
    children: [
      {
        path: 'graphs',
        loadComponent: () => import('./list/financial.component').then((m) => m.FinancialComponent),
      },
      {
        path: 'coupon',
        loadComponent: () => import('./coupon/coupon.component').then((m) => m.CouponComponent),
        canActivate: [individualRestrictionGuard],
      },
      {
        path: 'coupon-details/:id',
        loadComponent: () => import('./coupon-details/coupon-details.component').then((m) => m.CouponDetailsComponent),
        canActivate: [individualRestrictionGuard],
      },
    ],
  },
];
@NgModule({
  imports: [RouterModule.forChild(admin)],
  exports: [RouterModule],
})
export class financialRoutingModule {
  static routes = admin;
}
